import React from 'react';
import { CoreEntraIdUserTrackingConflict, CoreEntraIdUserTrackingConflictType, CoreEntraIdUserTrackingFlowSyncConflict, CoreEntraIdUserTrackingGraphConflict } from '../../../../models/CoreTrackingOperation';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface EntraIdUserTrackingOperationsValidationResultProps {
    entraIdId?: string
    primarySmtpAddress?: string
    userPrincipalName?: string
    conflicts: CoreEntraIdUserTrackingConflict[]
}

const EntraIdUserTrackingOperationsValidationResult: React.FC<EntraIdUserTrackingOperationsValidationResultProps> = (props) => {
    const conflictLookup = new Map<CoreEntraIdUserTrackingConflictType, CoreEntraIdUserTrackingConflict[]>();
        const { t } = useTranslation(['schoolAdministration', 'common']);
    
    props.conflicts.forEach((conflict) => {
        const conflicts = conflictLookup.get(conflict.type);
        if (conflicts) {
            conflicts.push(conflict);
        } else {
            conflictLookup.set(conflict.type, [conflict]);
        }
    });

    
    const getText = (conflictType: CoreEntraIdUserTrackingConflictType, entraIdId?: string, primarySmtpAddress?: string, userPrincipalName?: string): string => {
    
        switch (conflictType) {
            case CoreEntraIdUserTrackingConflictType.TrackingKey:
                return t('trackingOperations.entraId.validationResult.connectionExistsFlowsyncEntraId', {ns: 'schoolAdministration', EntraIdId: entraIdId});            
            case CoreEntraIdUserTrackingConflictType.SourceObjectType:
                return t('trackingOperations.entraId.validationResult.connectionExistsPersonRole', {ns: 'schoolAdministration'});
            case CoreEntraIdUserTrackingConflictType.Identifier:
                return t('trackingOperations.entraId.validationResult.connectionExistsUpnEntraId', {ns: 'schoolAdministration', EntraIdId: entraIdId});
            case CoreEntraIdUserTrackingConflictType.EmailAddress:
                return t('trackingOperations.entraId.validationResult.connectionExistsEmailEntraId', {ns: 'schoolAdministration', PrimarySmtpAddress: primarySmtpAddress});
            case CoreEntraIdUserTrackingConflictType.UserPrincipalName:
                return t('trackingOperations.entraId.validationResult.connectionExistsUpnEntraId', {ns: 'schoolAdministration', UserPrincipalName: userPrincipalName});
            case CoreEntraIdUserTrackingConflictType.GraphEmailAddress:
                return t('trackingOperations.entraId.validationResult.smtpEmailAlreadyExists', {ns: 'schoolAdministration', PrimarySmtpAddress: primarySmtpAddress});
            case CoreEntraIdUserTrackingConflictType.GraphUserPrincipalName:
                return t('trackingOperations.entraId.validationResult.usernameAlreadyExists', {ns: 'schoolAdministration', UserPrincipalName: userPrincipalName});
            default:
                return t('trackingOperations.entraId.validationResult.error', {ns: 'schoolAdministration'});
        }
    }

    return <>{Array.from(conflictLookup).sort((a, b) => a[0] - b[0]).map((entry) => (<>
        <p>{getText(entry[0], props.entraIdId, props.primarySmtpAddress, props.userPrincipalName)}</p>
        {renderConflicts(entry[0], entry[1])}
    </>))}
    </>;
}


const renderConflicts = (conflictType: CoreEntraIdUserTrackingConflictType, conflicts: CoreEntraIdUserTrackingConflict[]): React.ReactNode => {
    switch (conflictType) {
        case CoreEntraIdUserTrackingConflictType.TrackingKey:
        case CoreEntraIdUserTrackingConflictType.SourceObjectType:
            return null;
        case CoreEntraIdUserTrackingConflictType.Identifier:
        case CoreEntraIdUserTrackingConflictType.EmailAddress:
        case CoreEntraIdUserTrackingConflictType.UserPrincipalName:
            return <ul>
                {(conflicts as CoreEntraIdUserTrackingFlowSyncConflict[]).map((conflict) => (<li key={conflict.trackingId}><Link target="_blank" to={`/user/${conflict.flowSyncId}/trackings`}>{conflict.displayName}</Link></li>))}
            </ul>;
        case CoreEntraIdUserTrackingConflictType.GraphEmailAddress:
        case CoreEntraIdUserTrackingConflictType.GraphUserPrincipalName:
            return <ul>
                {(conflicts as CoreEntraIdUserTrackingGraphConflict[]).map((conflict) => (<li key={conflict.entraIdId}>EntraId: {conflict.displayName} ({conflict.userPrincipalName})</li>))}
            </ul>;
        default:
            return null;
    }
}

export default EntraIdUserTrackingOperationsValidationResult;
